import messages from './cmsDuplicate.json' with { type: 'json' };

export const cmsDuplicateFi: Readonly<typeof messages> = messages;
